
import * as THREE from 'three';

import Experience from '../Experience.js';

export default class Background {
    constructor() {
        this.experience = Experience.getInstance();
        this.camera = this.experience.camera.instance;
        this.scene = this.experience.scene;
        this.sizes = this.experience.sizes;

        this.init();
    }

    init() {
        const textureLoader = new THREE.TextureLoader();
        const imageTexture = textureLoader.load('/textures/tamagochi_device.png');
        imageTexture.encoding = THREE.sRGBEncoding;
        imageTexture.colorSpace = THREE.SRGBColorSpace;

        const imgGeometry = new THREE.PlaneGeometry(5, 5); // Adjust size
        const imgMaterial = new THREE.MeshStandardMaterial({
            map: imageTexture,
            transparent: true
        });

        this.imgMesh = new THREE.Mesh(imgGeometry, imgMaterial);
        this.imgMesh.position.set(0, 0, -3.2); // Place in front of the sphere

        this.imgMesh.renderOrder = 2;

        this.camera.add(this.imgMesh);
    }


    update() {
        
    }

    resize() {

    }
}